/** @format */

function FooterBlock() {
  return (
    <footer className="footer">
      <p>
        by{" "}
        <a href="https://geongeorge.com/" target="_blank" rel="noreferrer">
          geon
        </a>
      </p>
      <p>
        <a
          href="https://github.com/geongeorge/Life-in-Weeks"
          target="_blank"
          rel="noreferrer"
        >
          github
        </a>
      </p>
    </footer>
  );
}

export default FooterBlock;
